const s = {
  name: "Door",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17,4h7v17h-7V4z M19,6v13h3V6H19z"/>
		<path class="st0" d="M15,4H8v17h7V4z M10,19V6h3v13H10z"/>
		<path class="st0" d="M8,23v2h4v-2H8z"/>
		<path class="st0" d="M4,0h24v38h4v2H0v-2h4V0z M26,2H6v36h20V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Door
};
